import DatePickerWithCustomInput from "pages/_components/fields/datepicker/DatePickerWithCustomInput";

// eslint-disable-next-line max-len
export { DatePickerWithCustomInputLatestVersion } from "pages/_components/fields/datepicker/latest-version/DatePickerWithCustomInput";

export default DatePickerWithCustomInput;
